import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function FundingRepaymentTrialsForm({ fundingActualRepaymentTrials }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Repayment Trials:</Form.Label>
      </Col>
      <Col md={1} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="trials"
          id="trials"
          value={fundingActualRepaymentTrials}
          readOnly
        />
      </Col>
    </>
  );
}

export default memo(FundingRepaymentTrialsForm);
